import { inject, Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { appendToRmaStaticImageUrl } from '@rma/generic/ng/util';
import { rmaIcons } from '../domain/rma-icons.const';

@Injectable({ providedIn: 'root' })
export class CustomIconService {
  private readonly iconRegistry = inject(MatIconRegistry);
  private readonly rmaStaticImageUrl = inject(appendToRmaStaticImageUrl);
  private readonly sanitizer = inject(DomSanitizer);

  public static svgIcons = rmaIcons;

  public register(): void {
    const icons = [...rmaIcons];
    icons.forEach((icon) =>
      this.iconRegistry.addSvgIcon(icon.name, this.sanitizer.bypassSecurityTrustResourceUrl(this.rmaStaticImageUrl(icon.location))),
    );
  }
}
